import { Component } from "@angular/core";

@Component({
    selector: 'hx-accordion-body, hxa-accordion-body',
    template: `<ng-content></ng-content>`
})
export class AccordionBodyComponent {
}